import type { CardsSectionTabBlockViewModel } from '../../ViewModel/CardsSectionTab/CardsSectionTabBlockViewModel.csharp';
import type { CardsSectionTabItemBlockViewModel } from '../../ViewModel/CardsSectionTabItem/CardsSectionTabItemBlockViewModel.csharp';
import type { CardProps } from '~/Partials/Card/Card';
import type { CardsSectionTabContent } from '~/Partials/CardsSection/CardsSectionTabs/CardsSectionTabs';

export const mapTabs = (tabs: CardsSectionTabBlockViewModel[]): CardsSectionTabContent[] => {
    const mapTabItems = (items: CardsSectionTabItemBlockViewModel[]): CardProps[] =>
        items.map(item => ({
            heading: item.heading,
            content: item.content,
            link: item.link,
        }));

    return tabs.map(tab => ({
        heading: tab.heading,
        items: mapTabItems(tab.items),
    }));
};
